import React, { useEffect, useState } from 'react';
import './ReconnectingBanner.css';

// Non-blocking strip shown at the top of the form when ref validation has
// been failing for `delayMs` or longer. Lets the user keep using the kiosk;
// gives operators on-site a visible signal without burying it in logs.
export default function ReconnectingBanner({ visible, delayMs = 30000 }) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!visible) {
      setShown(false);
      return;
    }
    const t = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(t);
  }, [visible, delayMs]);

  if (!shown) return null;

  return (
    <div className="reconnecting-banner" role="status" aria-live="polite">
      <span className="reconnecting-banner__icon" aria-hidden>🔌</span>
      <span className="reconnecting-banner__text">
        Reconnecting… your feedback will still be sent.
      </span>
    </div>
  );
}
